import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useDeleteContact() {
  const api = useAxios();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (contactId) => {
      return api.delete(`/contacts/${contactId}`);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["contacts"] });
    },
  });
}